<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-delete-card"
      scrollable
      centered
      button-size="sm"
    >
      <template #modal-title>
        <i class="fas fa-user-minus"></i>&nbsp; EXCLUSÃO DO LEAD
      </template>
      <div class="form-group row pt-3 pb-3">
        <div class="col-md-12 text-center">
          <h5>
            Deseja realmente excluir o cartão do Lead
            <div class="pt-2">
              <strong>{{ leadName }}</strong
              >?
            </div>
          </h5>
          <br />
        </div>
      </div>
      <template #modal-footer>
        <button
          type="button"
          class="btn rounded btn-default btn-sm"
          @click="hideModal"
          v-b-tooltip.hover
          :title="'Não'"
        >
          <i class="fas fa-times-circle"></i
          ><span class="d-md-down-none"> Não</span></button
        >&nbsp;
        <button
          type="button"
          class="btn rounded btn-danger btn-sm"
          @click="onDelete"
          v-b-tooltip.hover
          :title="'Sim'"
        >
          <i class="fas fa-minus-circle"></i
          ><span class="d-md-down-none"> Sim</span>
        </button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'CardDeleteModal',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null
    }
  },
  computed: {
    leadName () {
      let result = ''
      if (this.data && this.data.pessoa && this.data.pessoa.nome) {
        result = this.data.pessoa.nome
      }
      return result
    }
  },
  methods: {
    showModal (data) {
      this.data = data
      this.$refs['modal-delete-card'].show()
    },
    hideModal () {
      this.$refs['modal-delete-card'].hide()
    },
    onLoad () {},
    onDelete () {
      if (this.data) {
        loading.push()
        BoardRepositoryV2.Card_Delete(
          this.data.boardColumn.board.id,
          this.data.boardColumn.id,
          this.data.id
        )
          .then((response) => {
            loading.pop()
            if (response.status === 200) {
              toast.success(this.$lang.Common.Alerts.Success)
            }
            this.hideModal()
            this.$emit('Back')
          })
          .catch(this.onException)
      } else {
        toast.success('Não foi possível localizar o Lead!', 'EXCLUSÃO DO LEAD')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/modal/carddeletemodal.vue